export const IS_SIGNED_IN = "authorization/SIGNED_IN";
export const IS_NOT_SIGNED_IN = "authorization/NOT_SIGNED_IN";

export const IS_PREMIUM = "authorization/PREMIUM";
export const IS_ADMIN = "authorization/ADMIN";
